import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import Placeholder from 'Components/Placeholder';
import Stat from 'Edits/Stat';

registerBlockType('eformv4/eform-stat', {
	title: __('Form Statistics - eForm', 'ipt_fsqm'),
	icon: 'chart-area',
	category: 'eform-v4',
	attributes: {
		...eFormGTB.attributes['eform-stat'],
	},

	edit({ attributes, className, setAttributes }) {
		const title = __('Form Statistics', 'ipt_fsqm');
		const message = __(
			'Statistical breakdown of submission and scores for forms and/or users',
			'ipt_fsqm'
		);

		return (
			<Placeholder className={className} title={title} message={message}>
				<Stat type="daywise" {...{ attributes, setAttributes }} />
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
